import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ListingCard.css';
import PropTypes from 'prop-types';
import RatingDisplay from './RatingDisplay';
import VerificationBadge from './VerificationBadge';

const ListingCard = ({ listing, onDelete, isOwner = false }) => {
  const {
    id,
    title,
    description,
    price,
    delivery_available,
    location,
    created_at,
    user,
    image_path,
    images
  } = listing;

  // Handle both image_path (from backend) and images array (for future compatibility)
  const imageUrl = image_path ? { image_path } : (images && images.length > 0 ? images[0] : null);

  // Format price to 2 decimal places
  const formattedPrice = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(price);

  // Format date
  const formattedDate = new Date(created_at).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });

  const handleDelete = (e) => {
    e.preventDefault();
    if (window.confirm('Are you sure you want to delete this listing?')) {
      onDelete(id);
    }
  };

  return (
    <div className="listing-card">
      <div className="listing-image">
        {imageUrl ? (
          <img
            src={"https://local-api.stratfordtreasurehunt.com" + imageUrl.image_path}
            alt={title}
          />
        ) : (
          <div className="no-image">No Image</div>
        )}
      </div>
      <div className="listing-content">
        <h3>{title}</h3>
        <p className="price">{formattedPrice}</p>
        <p className="description">{description}</p>
        <div className="seller-info">
          <div className="seller-details">
            <span className="seller-name">by {user.name || 'Unknown Seller'}</span>
            {user.verification_status && (
              <VerificationBadge 
                verificationStatus={user.verification_status} 
                size="small" 
              />
            )}
          </div>
          {user.rating && (
            <RatingDisplay
              rating={user.rating.average_rating}
              totalRatings={user.rating.total_ratings}
              size="small"
            />
          )}
        </div>
        <div className="listing-details">
          <span className="location">{location}</span>
          <span className="delivery">
            {delivery_available ? 'Delivery Available' : 'Pickup Only'}
          </span>
        </div>
        <div className="listing-actions">
          <Link
            to={`/listings/${id}`}
            className="view-btn"
          >
            View Details
          </Link>
          {isOwner && (
            <>
              <Link
                to={`/listings/${id}/edit`}
                className="edit-btn"
              >
                Edit
              </Link>
              <button
                className="delete-btn"
                onClick={handleDelete}
              >
                Delete
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

ListingCard.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    delivery_available: PropTypes.bool.isRequired,
    location: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      verification_status: PropTypes.shape({
        verified_email: PropTypes.bool,
        verified_phone: PropTypes.bool,
        verified_id: PropTypes.bool
      }),
      rating: PropTypes.shape({
        average_rating: PropTypes.number,
        total_ratings: PropTypes.number
      })
    }),
    image_path: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape({
      image_path: PropTypes.string.isRequired
    }))
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  isOwner: PropTypes.bool
};

export default ListingCard; 